export const styleConstant = {
  color: "#ffc107",
  bgColor: "bg-dark",
  border: "border-bottom border-light",
  textColor: "text-light",
};

export const onHoverStyleConstant = {
    color: "white",
    bgColor: "bg-warning",
    border: "border-bottom border-dark",
    textColor: "text-dark",
  };
